<template>
  <div>
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/quotes')"
      class=""
    />
    <van-list
      v-model="loadingQuotesDetails"
      :finished="finishedQuotesDetails"
      finished-text=""
      @load="onLoad"
    >
      <van-row class="tableTitle">
        <van-col span="6" style="text-align: left"
          ><span>{{ columnTitleOne }}</span></van-col
        >
        <van-col span="6" style="text-align: center"
          ><span>{{ columnTitleTwo }}</span></van-col
        >
        <van-col span="6" style="text-align: center"
          ><span>{{ columnTitleThree }}</span></van-col
        >
        <van-col span="6" style="text-align: right"
          ><span>{{ columnTitleFour }}</span></van-col
        >
      </van-row>
      <div v-for="(item, index) in dataList" :key="index" @click="onItem(item)">
        <van-row class="tablecontent"
          ><van-col span="6"
            ><span>{{ item.name }} <br />{{ item.code }}</span></van-col
          >
          <!--item[1]item[0] -->
          <van-col span="6" style="padding-top: 10px; text-align: center"
            ><span
              v-bind:class="[
                item.zhi2.substring(0, 1) == '-' ? 'greenText' : 'redText',
              ]"
              >{{ item.zhi1 }}</span
            ></van-col
          >
          <van-col span="6" style="padding-top: 10px; text-align: center"
            ><span
              v-bind:class="[
                item.zhi2.substring(0, 1) == '-' ? 'greenText' : 'redText',
              ]"
              >{{ item.zhi2 }}</span
            ></van-col
          >
          <!--item[2] -->
          <van-col span="6" style="padding-top: 10px; text-align: right"
            ><span
              v-bind:class="[
                item.zhi2.substring(0, 1) == '-' ? 'greenText' : 'redText',
              ]"
              >{{ item.zhi3 }}</span
            ></van-col
          ><!--item[3] -->
        </van-row>
      </div>
    </van-list>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "QuotesDetails",
  data() {
    return {
      title: "",
      dataList: "",
      // list: [],
      upStock: [],
      downStock: [],
      quotesId: sessionStorage.getItem("quotesId"),
      loadingQuotesDetails: false,
      finishedQuotesDetails: false,
      page: 1,
      columnTitleOne: "",
      columnTitleTwo: "",
      columnTitleThree: "",
      columnTitleFour: "",
    };
  },
  methods: {
    onItem(item) {
      this.$router.push({ name: "Kline", params: { code: item.shortCode } });
    },
    get_stock_up() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hs_up",
            page: that.page,
            num: 20,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.filter(e => !e.shortCode.startsWith('bj'))
               .forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });

      // $.ajax({
      //   cache: true,
      //   url: "https://hq.sinajs.cn/list=new_all_changepercent_up",
      //   type: "GET",
      //   dataType: "script",
      //   success: function () {
      //     let elements = eval("hq_str_new_all_changepercent_up");
      //     that.list = eval("(" + elements + ")");
      //     that.loadingQuotesDetails = false;
      //     that.finishedQuotesDetails = true;
      //   },
      // });
    },
    get_stock_down() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hs_down",
            page: that.page,
            num: 20,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.filter(e => !e.shortCode.startsWith('bj'))
               .forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url: "https://hq.sinajs.cn/list=new_all_changepercent_down",
      //   type: "GET",
      //   dataType: "script",
      //   success: function () {
      //     let elements = eval("hq_str_new_all_changepercent_down");
      //     that.list = eval("(" + elements + ")");
      //     that.loadingQuotesDetails = false;
      //     that.finishedQuotesDetails = true;
      //   },
      // });
    },
    get_turnoverrate() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hs_amount",
            page: that.page,
            num: 20,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.filter(e => !e.shortCode.startsWith('bj'))
               .forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url: "https://hq.sinajs.cn/list=new_all_turnoverrate",
      //   type: "GET",
      //   dataType: "script",
      //   success: function () {
      //     let elements = eval("hq_str_new_all_turnoverrate");
      //     that.list = eval("(" + elements + ")");
      //     that.loadingQuotesDetails = false;
      //     that.finishedQuotesDetails = true;
      //   },
      // });
    },
    get_stock_sz_up() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hs_up_5min_20",
            page: that.page,
            num: 20,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.filter(e => !e.shortCode.startsWith('bj'))
               .forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url: "https://hq.sinajs.cn/list=stock_sz_up_5min_20",
      //   type: "GET",
      //   dataType: "script",
      //   success: function () {
      //     let elements = eval("hq_str_stock_sz_up_5min_20");
      //     that.list = eval("(" + elements + ")");
      //     that.loadingQuotesDetails = false;
      //     that.finishedQuotesDetails = true;
      //   },
      // });
    },
    get_stock_sz_down() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hs_down_5min_20",
            page: that.page,
            num: 20,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.filter(e => !e.shortCode.startsWith('bj'))
               .forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url: "https://hq.sinajs.cn/list=stock_sz_down_5min_20",
      //   type: "GET",
      //   dataType: "script",
      //   success: function () {
      //     let elements = eval("hq_str_stock_sz_down_5min_20");
      //     that.list = eval("(" + elements + ")");
      //     that.loadingQuotesDetails = false;
      //     that.finishedQuotesDetails = true;
      //   },
      // });
    },
    get_si_api() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hs_tor",
            page: that.page,
            num: 20,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.filter(e => !e.shortCode.startsWith('bj'))
               .forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url: "https://hq.sinajs.cn/list=si_api0",
      //   type: "GET",
      //   dataType: "script",
      //   success: function () {
      //     let elements = eval("hq_str_si_api0");
      //     that.list = eval("(" + elements + ")");
      //     that.loadingQuotesDetails = false;
      //     that.finishedQuotesDetails = true;
      //   },
      // });
    },
    onLoad() {
      let quotesID = this.quotesId;
      if (quotesID == 1) {
        this.get_stock_up();
        this.title = "涨幅榜";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
        this.columnTitleFour = "最高";
      } else if (quotesID == 2) {
        this.get_stock_down();
        this.title = "跌幅榜";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
        this.columnTitleFour = "最低";
      } else if (quotesID == 3) {
        this.get_turnoverrate();
        this.title = "成交额";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
        this.columnTitleFour = "成交额/万";
      } else if (quotesID == 4) {
        this.get_stock_sz_up();
        this.title = "涨速榜";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
        this.columnTitleFour = "5分钟涨速";
      } else if (quotesID == 5) {
        this.get_stock_sz_down();
        this.title = "跌速榜";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
        this.columnTitleFour = "5分钟涨速";
      } else if (quotesID == 6) {
        this.get_si_api();
        this.title = "换手率";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
        this.columnTitleFour = "换手率";
      } else {
      }
    },
  },
  mounted: function () {
    this.dataList = [];
    this.finishedQuotesDetails = false;
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.tablecontent {
  font-size: 14px;
  padding: 10px;
}
.tableTitle {
  font-size: 14px;
  padding-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: bold;
}
.redText {
  color: #ff2c27;
}
.greenText {
  color: #008000;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotesDetails.vue